import React, { useState } from "react";
import { Typography, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../App.css";
import WebCheckInLayout from "./WebCheckInLayout";
import BookingGetters from "../../store/onlineBooking/getters";

type Props = {
  details: any;
  onBack: () => void;
  onNext?: (answer: string) => void;
  progress: any;
  answer?: string;
};

export default function RentalContractFirstDriver({
  details,
  onBack,
  onNext,
  progress,
  answer: initialAnswer = "",
}: Props) {
  if (!details) return null;
  const { t: translate } = useTranslation();
  const [answer, setAnswer] = useState("");

  const handleChange = (value: string) => {
    setAnswer(value);
    if (onNext) {
      onNext(value);
    }
  };

  const appSettings = BookingGetters.getAppSettings();
  const webCheckinSecondaryColor = appSettings?.webCheckinSecondaryColor;
  const styles = {
    radioLabel: {
      fontWeight: "bold",
    },
    yesColor: {
      color: `${webCheckinSecondaryColor || "#E0007A"} !important`,
    },
    noColor: {
      color: `${webCheckinSecondaryColor || "#E0007A"} !important`,
    },
  };

  return (
    <WebCheckInLayout
      title={translate("Driver Details")}
      progress={progress}
      onBack={onBack}
    >
      <Typography variant="body1" className="webCheckInText">
        {translate("Is the rental contract signer also the first driver?")}
      </Typography>
      <RadioGroup
        row
        value={answer}
        onChange={(e) => handleChange(e.target.value)}
        style={{
          justifyContent: "center",
          marginTop: "20px",
          marginBottom: "10px",
        }}
      >
        <FormControlLabel
          value="yes"
          control={<Radio sx={styles.yesColor} />}
          label={translate("YES")}
          sx={styles.radioLabel}
        />
        <FormControlLabel
          value="no"
          control={<Radio sx={styles.noColor} />}
          label={translate("NO")}
          sx={styles.radioLabel}
        />
      </RadioGroup>
    </WebCheckInLayout>
  );
}
